import { render, staticRenderFns } from "./ResetInfo.vue?vue&type=template&id=0c73ac2f"
import script from "./ResetInfo.vue?vue&type=script&lang=js"
export * from "./ResetInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports